import { render } from "./Links.vue?vue&type=template&id=3ae858ba&bindings={\"links\":\"data\"}"
import script from "./Links.vue?vue&type=script&lang=js"
export * from "./Links.vue?vue&type=script&lang=js"
script.render = render

export default script